// Auto-generated - do not edit manually
import React from "react";
import { BaseIcon } from "../BaseIcon";
import type { CurrencyIconProps } from "../types";

const coloredContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><path d="M22 7L17 12L21.9854 16.9854L16.9854 21.9854L12 17L7 22L2 17L7 12L2 7L7 2L12 7L17 2L22 7ZM8 12L12.001 16L16.001 12L12.001 7.99903L8 12Z" fill="#E89331"/></svg>`;
const monoContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><path d="M22 7L17 12L21.9854 16.9854L16.9854 21.9854L12 17L7 22L2 17L7 12L2 7L7 2L12 7L17 2L22 7ZM8 12L12.001 16L16.001 12L12.001 7.99903L8 12Z" style="fill: currentColor"/></svg>`;

export const XsollaZk: React.FC<CurrencyIconProps> = (props) => (
  <BaseIcon
    {...props}
    coloredContent={coloredContent}
    monoContent={monoContent}
  />
);
